import React from 'react';
import { COMPONENT_RESIZE } from '../../common/GoldenLayoutWrapper';
import { getCurrentDate } from '../../helpers/Common';
import SearchBox from './common/SearchBox';
import { connect } from 'react-redux';
import PriceInfo from './PriceInfo';
import { I18n } from 'react-redux-i18n';
import ScoreBox from './Score';
import GroupButton from '../common/header/group-button';
import Noti from './Noti';
import { Export } from '../../common/export';
import Const from './Const';
import { REDUCER_NAME } from './reducer';
import { withComponentId } from '../../common/ComponentIdContext';
import { compose } from 'redux';

class SmallFAHead extends React.Component {
  getExportName = () => {
    const { currentSearch } = this.props;
    return I18n.t('common.export.snapshot', {
      ticker: currentSearch.displayCode,
      date: getCurrentDate(),
    });
  };
  render() {
    const { dragCode, id, currentSearch } = this.props;
    const idFormExport = 'fa-snapshot-export' + id;

    return (
      <div
        ref={this.rootRef}
        className="fa-top-content top-nav flex-column h-100 small-head"
      >
        <div className="d-flex mb-10">
          <div className="d-flex w-100 flex-column">
            <div className="d-flex align-items-center">
              <div className="d-flex flex-fill justify-content-between flex-wrap">
                <div className="d-flex flex-column mr-20" id="search">
                  <SearchBox />
                  <PriceInfo dragCode={dragCode} />
                </div>

                <div className="d-flex align-items-center">
                  <ScoreBox dragCode={dragCode} />
                  <GroupButton code={currentSearch.displayCode} />
                </div>
              </div>
            </div>
            <div className="d-flex mt-8 mb-8">
              <div className="d-flex">
                <Noti id={id} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => ({
  i18n: state.i18n,
  currentSearch:
    state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
  companyScore: state[REDUCER_NAME].listMultiComponent[componentId].score,
});

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(SmallFAHead);
